/**
 * List pulled from Vault repo.
 * `/src/utility/MimeMapping.ts`
 */
export const FILE_TYPES_WHITELIST = [
	'doc',
	'dot',
	'docx',
	'gif',
	'jpe',
	'jpg',
	'jpeg',
	'bmp',
	'dib',
	'pdf',
	'png',
	'pnz',
	'ppt',
	'pot',
	'pps',
	'pptx',
	'tif',
	'tiff',
	'txt',
	'xlm',
	'xls',
	'xlt',
	'xlsx',
	'z',
	'zip',
	'csv',
];

export const IMAGE_FILE_TYPES = ['jpg', 'jpeg', 'jpe', 'jif', 'jfif', 'jfi', 'png', 'gif', 'webp', 'tiff', 'tif', 'bmp', 'dib', 'svg', 'svgz'];

export const EMBEDDABLE_FILE_TYPES = ['aac', 'avi', 'htm', 'html', 'midi', 'mp3', 'mp4', 'mpeg', 'pdf', 'ts', 'txt', 'wav', 'weba', 'webm', 'xhtml'];

export const ICON_BY_FILE_TYPE_DEFAULT_ICON = 'insert_drive_file';

export const REPORT_FILE_TYPES = { PDF: 'PDF', XLSX: 'XLSX', CSV: 'CSV' };
